import React from "react";
import {View, Text} from "@react-pdf/renderer";
import PropTypes from "prop-types";

import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {getCartItemName} from "./printDocumentFunctions";

const PrintDocumentBodyWizardItem = (props) => {

  const {styles, wizardGroup, selectedFeature, fabricatorData, printContext, locale} = props;

  return (
    <View wrap={true}>
      <Text style={styles.subPartTitle}>
        {wizardGroup.title || wizardGroup.groupName}
      </Text>
      <View style={styles.cartItem} wrap={true}>
        <View wrap={false}>
          <Text style={styles.cartItemName}>
            {selectedFeature
              ? getCartItemName(selectedFeature, fabricatorData, printContext, locale)
              : wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
          </Text>
          <View style={styles.cartItemInfo}>
            <Text style={styles.wizardItemDescription}>
              {wizardGroup.productCartDescription || ""}
            </Text>
          </View>
        </View>
      </View>
    </View>
  )
};

PrintDocumentBodyWizardItem.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  // locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyWizardItem
